module.exports = __webpack_public_path__ + "static/media/preview-icon.159c9474.png";